// parcel-served URLs
import headerUrl from "url:../includes/header.html";
import heroUrl from "url:../includes/hero.html";
import featuresUrl from "url:../includes/features.html";
import workflowUrl from "url:../includes/workflow.html";
import pricingUrl from "url:../includes/pricing.html";
import footerUrl from "url:../includes/footer.html";

export const FRAG_URLS = {
	"/includes/header.html": headerUrl,
	"/includes/hero.html": heroUrl,
	"/includes/features.html": featuresUrl,
	"/includes/workflow.html": workflowUrl,
	"/includes/pricing.html": pricingUrl,
	"/includes/footer.html": footerUrl,
};
